export const updateObject = (oldObject, updatedProperties) => {
  return {
      ...oldObject,
      ...updatedProperties
  };
};

export const objectEncode = object => {
  return JSON.stringify(object)
};